import { CustomerAPI } from 'api'

import { map, is } from 'ramda'

export const createStaticSegment = (segment) => (
  CustomerAPI.post(`/user_lists`, segment)
)

export const addToMemberList = (users, segmentId) => (
  CustomerAPI.patch(`/user_lists/${segmentId}/members`, users)
)

export const getStaticSegments = (orgId) => (
  CustomerAPI.get(`/user_lists`, {params: {type: 'ID_LIST'}})
)

export const getFilteredContacts = (query, size = 25, startFrom = 0) => (
  CustomerAPI.post(`/segment/filter`, query, {params: {size, from: startFrom}})
)

export const searchContacts = ({ query = {}, size = 25, sortAscended, sortField, startFrom = 0 }) => {
  const params = {
    from: startFrom,
    size,
    sortAscended,
    sortField,
  }

  let body = {}

  if (is(String, query)) {
    params.q = query
  } else if (is(Object, query)) {
    body = query
  }

  return CustomerAPI.post(`/segment/search`, body, { params })
}

export const newCreateSegment = (query) => (
  CustomerAPI.post(`/segment/create`, query)
)

export const getContactSegmentsByNameQuery = (query, size = 25, startFrom = 0) => (
  CustomerAPI.get(`/user_lists/paginated/v2`, {params: { nameFilter: query, size, from: startFrom }} )
)

export const getContactSegmentsByType = (size = 25, startFrom = 0, filter) => (
  CustomerAPI.get(`/user_lists/paginated/v2`, {params: { typeFilter: filter, size, from: startFrom }})
)

export const getContactSegments = (size = 25, startFrom = 0) => (
  CustomerAPI.get(`/user_lists/paginated/v2`, {params: { size, from: startFrom }})
)

export const getContactSegmentsByTypeAndName = (size = 25, startFrom = 0, type, query) => (
  CustomerAPI.get(`/user_lists/paginated/v2`, {params: { size: size, from: startFrom, typeFilter: type, nameFilter: query }})
)

/**
 * Fetch hydrated members of a contact segment.
 */
export const getNewSegmentList = ({id, startFrom, size}) => (
  CustomerAPI.get(`/segment/members/hydrate/${id}`, {timeout: 30000, params: {size, from: startFrom}})
)

export const findMembershipInNewSegment =  (id, startFrom, size, query) => (
  CustomerAPI.get(`/segment/members/hydrate/${id}`, {params: {size, from: startFrom, nameOrEmail: query}})
)

export const archiveSegments = async (segments) => {
  const archiveGroup = map((id) => CustomerAPI.delete(`/segment/archive/${id}`), segments)
  return Promise.all(archiveGroup)
}

export const archiveSingleSegment = (segmentId) => {
  return archiveSegments([segmentId])
}

export const exportSegmentCSV = (id, email) => (
  CustomerAPI.post(`/user_lists/${id}/members/csv/email`, { "emailId" : email })
)

export const getSegmentQuery = (id) => (
  CustomerAPI.get(`/segment/query/${id}`)
)

export const deleteAllMembersInSegment = (orgId, segmentId) => (
  CustomerAPI.delete(`/organizations/${orgId}/end_users/user_list/${segmentId}`)
)

export const downloadSegmentCSV = (id) => {
  return CustomerAPI.get(`/user_lists/${id}/members/csv`).then((response) => response.data)
}